import {Email} from '../email/email';

export class Leaf {

    private _name ='';
    private _email:Email;
    private _path = '';
    private _templateId = '';
    private _id = 0;
    constructor(val:string) {
        this._name = val;
    }


    getPath(): string {
        return this._path;
    }

    setPath(value: string) {
        this._path = value;
    }

    getEmail(): Email {
        return this._email;
    }

    setEmail(value: Email) {
        this._email = value;
    }

    getName(): string {
        return this._name;
    }

    setName(value: string) {
        this._name = value;
    }


    getTemplateId(): string {
        return this._templateId;
    }

    setTemplateId(value: string) {
        this._templateId = value;
    }
}
